<template>
  <div :class="`flight-pad-stops flight-pad-stops__${color} semibold`">
    <vb-icon v-if="duration" name="time" :size="16"/>
    <span v-if="itinerary.segments.length === 1"> diretto </span>
    <span v-else-if="itinerary.segments.length > 1">
      <span v-if="!hide_quantity">{{ itinerary.segments.length - 1 }}</span>
      scal{{ itinerary.segments.length > 2 && !hide_quantity ? 'i' : 'o' }}
      <span class="flight-pad-stops__iata">{{ stop_codes }}</span>
    </span>
    <span v-if="duration">
      di
      <flight-pad-duration :duration="duration" :font_size="14" />
    </span>
  </div>
</template>

<script> 
import FlightPadDuration from '@liveflight/components/blocks/flight-pad/flight-pad-duration.vue';

export default {
  name: 'flight-pad-stops',
  components: {
    'flight-pad-duration': FlightPadDuration,
  },
  computed: {
    stop_codes() {
      return this.itinerary.segments
        .slice(0, -1)
        .map(s => s.arrival.iataCode)
        .join(', ');
    },
  },
  props: {
    itinerary: Object,
    color: {
      type: String,
      default: () => '',
    },
    hide_quantity: {
      type: Boolean,
      default: () => false,
    },
    duration: {
      type: String,
      default: () => '',
    },
  }, 
};
</script>

<style lang="scss" scoped>
.flight-pad-stops {
  width: max-content;
  display: flex;
  align-items: center;
  gap: 4px;
  &__primary {
    color: $azure;
  }
  font-size: 14px;
  border: 1px solid $light-gray;
  border-radius: 5px;
  padding-left: 10px;
  padding-right: 10px;

  &__iata {
    color: $dark;
  }
}
</style>
